export default __webpack_public_path__ + "static/media/Spotify1.77907aca.PNG";